import { Tooltip } from '@base-ui/react/tooltip';
import styled, { css } from 'styled-components';
import { breakpoints } from 'modules/breakpoints';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const ANIMATION_DISTANCE = 4;
const getFixedWidthStyles = (width) => {
    if (width === undefined) {
        return css `
      ${breakpoints.xs} {
        max-width: 90vw;
      }

      ${breakpoints.sm} {
        max-width: 40vw;
      }
    `;
    }
    return css `
    max-width: ${pxToRem(width)};
  `;
};
export const TooltipPopup = styled(Tooltip.Popup) `
  padding: ${themeGet('spacing.sm')} ${themeGet('spacing.md')};
  border-radius: ${themeGet('spacing.sm')};
  background-color: ${themeGet('colors.gray.1000')};
  ${(props) => getFixedWidthStyles(props.$width)};
  font-size: ${themeGet('fontSize.small')};
  color: ${themeGet('colors.gray.0')};
  user-select: none;
  opacity: 1;
  translate: none;
  will-change: transform, opacity;
  transition: all 125ms ease-out;

  &[data-starting-style] {
    opacity: 0;

    &[data-side='top'] {
      transform: translateY(-${pxToRem(ANIMATION_DISTANCE)});
    }

    &[data-side='right'] {
      transform: translateX(${pxToRem(ANIMATION_DISTANCE)});
    }

    &[data-side='bottom'] {
      transform: translateY(${pxToRem(ANIMATION_DISTANCE)});
    }

    &[data-side='left'] {
      transform: translateX(-${pxToRem(ANIMATION_DISTANCE)});
    }
  }

  &[data-ending-style] {
    opacity: 0;

    &[data-side='top'] {
      transform: translateY(-${pxToRem(ANIMATION_DISTANCE)});
    }

    &[data-side='right'] {
      transform: translateX(${pxToRem(ANIMATION_DISTANCE)});
    }

    &[data-side='bottom'] {
      transform: translateY(${pxToRem(ANIMATION_DISTANCE)});
    }

    &[data-side='left'] {
      transform: translateX(-${pxToRem(ANIMATION_DISTANCE)});
    }
  }
`;
export const TooltipArrow = styled(Tooltip.Arrow) `
  display: flex;

  &[data-side='top'] {
    bottom: -${pxToRem(6)};
    rotate: 180deg;
  }

  &[data-side='bottom'] {
    top: -${pxToRem(6)};
    rotate: 0deg;
  }

  &[data-side='left'] {
    right: -${pxToRem(11)};
    rotate: 90deg;
  }

  &[data-side='right'] {
    left: -${pxToRem(11)};
    rotate: -90deg;
  }
`;
export const ArrowFill = styled.path `
  fill: ${themeGet('colors.gray.1000')};
`;
